import React from 'react'
import { connect } from 'react-redux'
import { tagFunnel } from '../actions/tagmanager'
import { DispatchThunk } from '../actions/types'
import { convertToFile } from '../actions/upload'
import { selectCollapsed } from '../selectors/site'
import { CHECK_MY_PAPER, TEXT_FIELD } from '../util/dataTestIds'
import { StoreState } from '../reducer/types'
import { CheckPaperButton, PastePaperTextArea, DocumentTextAreaContainer } from '../styles'
import { PASTE_PAPER_COPY, CHECK_MY_PAPER_BUTTON_COPY } from '../constants'
import { ButtonAttributes } from '../types'

interface Props {
  buttonAttributes: ButtonAttributes
}

interface DocumentDispatchProps {
  handleCreateText: (...args: any[]) => any
}

interface DocumentStateProps {
  initialized: boolean
  initialCollapsed: boolean
}

export type DocumentTextProps = Props & DocumentStateProps & DocumentDispatchProps

export const DocumentText: React.FunctionComponent<DocumentTextProps> = ({
  handleCreateText,
  initialized,
  initialCollapsed,
  buttonAttributes,
}) => {
  const [text, setText] = React.useState('')
  const [collapsed, setCollapsed] = React.useState(initialCollapsed)

  const hasMinText = text.trim().length >= 50
  const textAreaHeight = collapsed ? '80px' : '200px'

  return (
    <DocumentTextAreaContainer>
      <PastePaperTextArea
        id="paste-paper-text-area"
        name="paste-paper"
        labelText={PASTE_PAPER_COPY}
        labelPlacement="floating"
        inputSize="medium"
        height={textAreaHeight}
        placeholder={PASTE_PAPER_COPY}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setText(e.target.value)}
        onClick={() => setCollapsed(false)}
        rows={15}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        data-test-id={TEXT_FIELD}
        aria-label={PASTE_PAPER_COPY}
      />
      <CheckPaperButton
        {...buttonAttributes}
        size="large"
        onClick={() => handleCreateText(text)}
        disabled={!hasMinText || !initialized}
        data-id="checkPaperButton"
        data-test-id={CHECK_MY_PAPER}
        type="submit"
      >
        {CHECK_MY_PAPER_BUTTON_COPY}
      </CheckPaperButton>
    </DocumentTextAreaContainer>
  )
}
const mapStateToProps = (state: StoreState): DocumentStateProps => ({
  initialized: state.app.initialized,
  initialCollapsed: selectCollapsed(state),
})
const mapDispatchToProps = (dispatch: DispatchThunk): DocumentDispatchProps => ({
  handleCreateText: (text: string) => {
    dispatch(convertToFile(text))
    dispatch(tagFunnel('upload paper', 'copy and paste'))
  },
})
export default connect<DocumentStateProps, DocumentDispatchProps>(
  // @ts-ignore
  mapStateToProps,
  mapDispatchToProps
)(DocumentText)
